import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-chip-filter-list',
  templateUrl: './chip-filter-list.component.html',
  styleUrls: ['./chip-filter-list.component.scss']
})
export class ChipFilterListComponent implements OnInit {

  @Input() chipsList: ChipFilterItem[] = [];
  @Output() removedItem = new EventEmitter<ChipFilterItem>();
  constructor() { }

  ngOnInit() {
  }

  removeFilter(chip: ChipFilterItem, i: number): void {
    this.removedItem.emit(this.chipsList[i]);
  }
}

export interface ChipFilterItem {
  Label: string;
  Id: string;
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/chip-filter-list/chip-filter-list.component.ts